import * as React from 'react';
import { IgcDropdownHeaderComponent as Component } from 'igniteui-webcomponents';
import { createComponent } from '../react-props.js';

/**
 * Represents a header item in a igc-dropdown list.
 * @slot  - Renders the header.
 * @class
 */
export const IgrDropdownHeader = /* @__PURE__ */ createComponent({
  tagName: 'igc-dropdown-header',
  displayName: 'IgrDropdownHeader',
  elementClass: Component,
  react: React,
});

export type IgrDropdownHeader = Component;

/** @deprecated Module register is no longer needed and can be removed */
export const IgrDropdownHeaderModule = Component;
